import styles from './OverlayApplicationProRss.module.css';
import Overlay from './Overlay.js';
import CallToActionButton from './CallToActionButton.js';
import ArticleTitle from './ArticleTitle.js';
import Background from './Background.js';
import Logo from './Logo.js';
import RssArticleLinks from './RssArticleLinks.js';
import RssFeedArticleTitle from './RssFeedArticleTitle.js';
import Theme from './Theme.js';
import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';

const OverlayApplicationProRss = () => {
  const {
    rssFeedArticleLinkColor: color,
    rssFeedBackgroundColor: backgroundColor,
  } = useSearchParamOrDefaultProps();

  return (
    <Theme>
      <Overlay>
        <div className={styles.overlayApplicationProRssWrapper}>
          <div
            className={styles.overlayApplicationProRssLeftWrapper}
            style={{ backgroundColor, color }}
          >
            <RssFeedArticleTitle />
            <RssArticleLinks />
          </div>

          <Background>
            <div className={styles.overlayApplicationProRssRightWrapper}>
              <Logo />
              <ArticleTitle />
              <CallToActionButton />
            </div>
          </Background>
        </div>
      </Overlay>
    </Theme>
  );
};

OverlayApplicationProRss.displayName = 'OverlayApplicationProRss';

export default OverlayApplicationProRss;
